import { useMessageSource } from "react-message-source";
import * as Yup from "yup";
import { useYesNoValidator } from "../shared/components/validator";

export default function useSignValidationScheme(canDigitallySign: boolean) {
  const { getMessage } = useMessageSource();
  const validateAcceptance = Yup.boolean().oneOf(
    [true],
    getMessage("Validation.message-mustAcceptTermsAndConditions"),
  );

  const validateAcceptTermsAndConditions = Yup.string().when(
    "wantsToDigitallySign",
    ([wantsToDigitallySign], schema) =>
      wantsToDigitallySign === "yes" ? validateAcceptance : schema,
  );

  const validateYesNo = useYesNoValidator();

  if (canDigitallySign) {
    return Yup.object().shape({
      wantsToDigitallySign: validateYesNo,
      acceptTermsAndConditions: validateAcceptTermsAndConditions,
    });
  }

  return null;
}
